<template>
  <div class="section6">
    <nav-menu @click="$emit('open')"></nav-menu>
    <div class="section4-container">
      <div class="title">DEEP CARE</div>
      <div class="subtitle">DEEP CARE</div>
      <!-- <p>可用于初级治疗，也可介入医疗手术结合使用</p> -->
      <div class="img-container">
        <div class="img-wrapper">
          <img :src="img03" alt="" />
        </div>
      </div>
      <!-- <h3 class="item-title">Activ CT9</h3> -->
      <p>提高手术效果，减少术后并发症。</p>
      <h3 class="item-title">应用领域：</h3>
      <ul>
        <li>· 医疗机构</li>
      </ul>
      <!-- <h3 class="item-title">适用机构：</h3>
      <ul>
        <li>· 健康美容机构（持有生活美容营业资质）</li>
        <li>· 应用领域2</li>
      </ul> -->
    </div>
  </div>
</template>

<script>
import NavMenu from "./components/NavMenu.vue";
export default {
  components: {
    NavMenu,
  },
  data() {
    return {
      img03: require("../../assets/home/mobile/section7/04.png"),
    };
  },
};
</script>
<style lang="less" scoped>
.section6 {
  padding: 1.8rem;
  padding-bottom: 0px;
  color: rgba(0, 0, 0, 0.65);
  position: relative;
  .title {
    font-size: 1.25rem;
    height: 1.4375rem;
    line-height: 1.4375rem;
    color: #000000;
    font-weight: 500;
  }
  .subtitle {
    color: #000000;
    opacity: 0.45;
    font-size: 0.75rem;
    margin-bottom: 0.75rem;
  }
  .img-container {
    height: 15rem;
    display: flex;
    align-items: center;
    background: rgba(245, 245, 245);
  }
  .img-wrapper {
    width: 100%;
    height: 10rem;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 8rem;
      height: 15rem;
      margin-top: -1.5rem;
    }
  }
  .item-title {
    height: 1.125rem;
    line-height: 1.125rem;
    font-size: 1rem;
    font-weight: 500;
    color: #000000;
    margin-bottom: 1rem;
  }
  p,
  ul {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
}
</style>
